import { render, staticRenderFns } from "./LabCategorySelect.vue?vue&type=template&id=a557543a&"
import script from "./LabCategorySelect.vue?vue&type=script&lang=js&"
export * from "./LabCategorySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports